import {
  Flex,
  Icon,
  Image,
  Stack,
  Tooltip,
  useBreakpointValue,
} from '@chakra-ui/react';
import React, { useContext, useEffect } from 'react';
import { FiMenu } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { AiFillExclamationCircle } from 'react-icons/ai';
import logo from '../../assets/logo-service-white.png';
import { ROUTER_PATHS, STORAGE } from '../../constants';
import { useSidebar } from '../../hooks/useSidebar';
import { Avatar } from './Avatar';
import { ColorfulBar } from './ColorfulBar';
import { CompanyFilter } from './CompanyFilter';
import { Notification } from '~/components/Header/Notification';
import { DownloadContext } from '~/contexts/DownloadContext/DownloadContext';

type Config = {
  drawerIsOpen: boolean;
};

export const Header: React.VFC = () => {
  const { isOpen, onToggle } = useSidebar();
  const { isActive } = useContext(DownloadContext);
  const isDrawerSidebar = useBreakpointValue({
    base: true,
    lg: false,
  });

  function setConfig() {
    localStorage.setItem(
      `${STORAGE}.config`,
      JSON.stringify({ drawerIsOpen: isOpen }),
    );
  }

  useEffect(() => {
    const { drawerIsOpen }: Config = JSON.parse(
      localStorage.getItem(`${STORAGE}.config`) || '{}',
    );

    if (drawerIsOpen) {
      if (isOpen !== drawerIsOpen) onToggle();
    } else {
      setConfig();
    }
  }, []);

  function handleToggle() {
    onToggle();
    setConfig();
  }

  return (
    <Flex flexDir="column" w="100%">
      <Flex bg="gray.900" px="4" py="2" align="center" justify="space-between">
        <Flex gridGap={2} align="center">
          <FiMenu
            color="white"
            size="24px"
            cursor="pointer"
            onClick={() => handleToggle()}
          />
          {!isDrawerSidebar && (
            <Link to={ROUTER_PATHS.PORTAL.HOME}>
              <Image ml="2" src={logo} maxW="100px" />
            </Link>
          )}
        </Flex>
        <Stack direction="row" spacing={8}>
          {isActive && (
            <Tooltip
              label="Existe um documento sendo processado."
              fontSize="md"
              hasArrow
              maxWidth="200px"
            >
              <span>
                <Icon as={AiFillExclamationCircle} color="yellow" w={6} h={6} />
              </span>
            </Tooltip>
          )}
          <CompanyFilter />
          <Notification />
          <Avatar />
        </Stack>
      </Flex>
      <ColorfulBar />
    </Flex>
  );
};
